<template>
  <div id="vTitle">
    <table class="ncut-page-title" style="margin-top:0px;" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
          <td class="ncut-page-title-text" style="text-align: left;">
            <i class="el-icon-star-off"></i><span>{{pageTitle}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'title',
  props: [
    'pageInfo'
  ],
  computed: {
    pageTitle: function () {
      let url = ''
      if ((this.$store.getters.getAppId == -2) && (this.$store.getters.getPageId == -2)) {
        url = '連絡我們'
      } else if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId 
        url = this.pageInfo[0].subMenu[appId].title + ' » ' + this.pageInfo[0].subMenu[appId].subMenu[pageId].title
      }
      console.log('======url===== :' + url)
      return url
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
    min-height: 20px;
    padding: 0.1em 0.2em;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
.ncut-page-title-text {
    font-family: "微軟正黑體";
    font-size: 1.5em;
    font-weight: 500;
    line-height: 1.1;
    color: #31708f;
}
.ncut-page-title {
    margin-top: 5px;
    height: 30px;
    border-bottom: 0px;
    width: 100%;
    background: linear-gradient(45deg,#fefcea 0%,#f1da36 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/TitlePage.vue